// @ts-nocheck baseline 2026-02-16
import { Pressable } from "react-native";
import { UnistylesRuntime } from "react-native-unistyles";
import { useRouter } from "expo-router";
import { View, Text, Card } from "@src/components";
import { AlarmDetailSchedule } from "@visioni/a3s-services-core";
import type { AlarmException } from "@src/services/api/types";
import { z } from "zod";
import { useTenantId } from "@src/features/tenants";
import { Icon } from "@src/components/Icon";

interface AppliedDiffersProps {
  applied: z.infer<typeof AlarmDetailSchedule>;
  exceptions?: AlarmException[];
  cameraKey: string;
  siteId: string;
}

export function AppliedDiffers({ cameraKey, siteId }: AppliedDiffersProps) {
  const theme = UnistylesRuntime.getTheme();
  const router = useRouter();
  const tenantId = useTenantId();

  return (
    <View px="5xl" pt="4xl" bg="background">
      <Pressable
        onPress={() => router.push(`/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}/alarms/applied-schedule`)}
      >
        <Card>
          <View flexDirection="row" justifyContent="space-between" alignItems="center">
            <View flex={1} flexDirection="row" alignItems="center" gap="md">
              <Icon name="infoOutline" size={20} color={theme.colors.blue[500]} />
              <View flex={1}>
                <Text textStyle="sm/medium" mb="xs">
                  Applying changes
                </Text>
                <Text textStyle="sm/regular" color="textMuted" mb="xs">
                  We&apos;re applying your changes to the camera.
                </Text>
              </View>
            </View>
            <Icon name="chevronRight" size={24} color={theme.colors.text} style={{ marginLeft: theme.spacing.xl }} />
          </View>
        </Card>
      </Pressable>
    </View>
  );
}
